module.exports = __webpack_public_path__ + "static/media/22.01ba0e47.jpg";